import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, ProtectedRoute } from "@/context/AuthContext";
import PublicLayout from "@/components/site/PublicLayout";
import AdminLayout from "@/components/admin/AdminLayout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Track from "@/pages/Track";
import TrackResult from "@/pages/TrackResult";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";
import NotFound from "@/pages/NotFound";
import Login from "@/pages/admin/Login";
import Dashboard from "@/pages/admin/Dashboard";
import Shipments from "@/pages/admin/Shipments";
import ShipmentNew from "@/pages/admin/ShipmentNew";
import ShipmentDetail from "@/pages/admin/ShipmentDetail";
import Messages from "@/pages/admin/Messages";
import ServicesAdmin from "@/pages/admin/ServicesAdmin";
import Settings from "@/pages/admin/Settings";
import AuditLog from "@/pages/admin/AuditLog";

const AuthShell = () => (
  <AuthProvider>
    <Outlet />
  </AuthProvider>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/admin" element={<AuthShell />}>
            <Route path="login" element={<Login />} />
            <Route element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
              <Route index element={<Dashboard />} />
              <Route path="spedizioni" element={<Shipments />} />
              <Route path="spedizioni/nuova" element={<ShipmentNew />} />
              <Route path="spedizioni/:code" element={<ShipmentDetail />} />
              <Route path="messaggi" element={<Messages />} />
              <Route path="servizi" element={<ServicesAdmin />} />
              <Route path="impostazioni" element={<Settings />} />
              <Route path="registro" element={<AuditLog />} />
            </Route>
          </Route>
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/chi-siamo" element={<About />} />
            <Route path="/servizi" element={<Services />} />
            <Route path="/traccia" element={<Track />} />
            <Route path="/traccia/:code" element={<TrackResult />} />
            <Route path="/contatti" element={<Contact />} />
            <Route path="/privacy" element={<Legal type="privacy" />} />
            <Route path="/cookie" element={<Legal type="cookie" />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
